import { render, staticRenderFns } from "./ToolBadge.vue?vue&type=template&id=2dac4edd&lang=pug"
import script from "./ToolBadge.vue?vue&type=script&lang=ts"
export * from "./ToolBadge.vue?vue&type=script&lang=ts"
import style0 from "./ToolBadge.vue?vue&type=style&index=0&id=2dac4edd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports